import {Component} from '@angular/core';

@Component({
    selector: 'app-cms-container',
    templateUrl: './cms-container.component.html',
    styleUrls: ['./cms-container.component.scss']
})
export class CmsContainerComponent {

}
